import React, { Component } from "react";
import Sidebar from './Sidebar'
import ReactToPrint from "react-to-print";
import { translate } from 'react-multi-lang'
import { connect } from "react-redux";
import { getHallTicketData } from '../../../actions/jobseekerAction'
import store from '../../../store'
import { Link } from 'react-router'

class HallTicket extends Component {

    constructor(props) {
        super(props);
        // this.printContent = React.createRef();
        this.printRef = React.createRef();

        this.state = {
            isLoading: true,
            mela_id: new URLSearchParams(this.props.location.search).get("mela-id")
        }
    }

    // handlePrint = () => {
    //     const content = this.printRef.current;

    //     const printWindow = window.open('', '', 'height=600,width=800');

    //     printWindow.document.write(`
    //       <html>
    //         <head>
    //           <title>Print Preview</title>
    //           <style>
    //             @media print {
    //               body {
    //                 -webkit-print-color-adjust: exact;
    //               }
    //             }
    //             body {
    //               font-family: Arial, sans-serif;
    //               padding: 20px;
    //             }
    //           </style>
    //         </head>
    //         <body>
    //           ${content.innerHTML}
    //         </body>
    //       </html>
    //     `);

    //     printWindow.document.close();

    //     printWindow.onload = function () {
    //         printWindow.focus();
    //         printWindow.print();
    //         printWindow.close();
    //     };
    // };


    handlePrint = () => {
        const content = this.printRef.current;

        const printWindow = window.open('', '', 'height=800,width=1000');

        printWindow.document.write(`
          <html>
            <head>
              <title>Hall Ticket</title>
              <style>
                body {
                  font-family: Arial, sans-serif;
                  padding: 20px;
                  font-size: 14px;
                  color: #000;
                }

                  .employervanue .job-data:first-of-type {
    border-radius: 4px;
    overflow: hidden;
  }

  .employervanue .job-data:first-of-type .row.m-0 {
    margin: 0;
  }

  .employervanue .job-data:first-of-type .row.m-0 > div {
    box-sizing: border-box;
    padding: 8px 0px;
    font-size: 12px;
    vertical-align: top;
  }

  .employervanue .job-data:first-of-type .row.m-0 > div:nth-child(4n) {
    border-right: 0;
  }

  .employervanue .job-data:first-of-type .row.m-0:last-child > div {
    border-bottom: 0;
  }

  .employervanue .job-data:first-of-type .font-weight-bold {
    background: #f7f7f7;
    font-weight: 700;
  }
      
                .text-center { text-align: center; }
                .fontW600 { font-weight: 600; }
                .fontW700 { font-weight: 700; }
                .mb-0 { margin-bottom: 0; }
                .mb-3 { margin-bottom: 1rem; }
                .p-2 { padding: 0.5rem; }
                .mt-4 { margin-top: 1.5rem; }
      
                h5, h6 {
                  margin: 5px 0;
                  font-weight: 600;
                }
      
                p {
                  font-size: 14px;
                  line-height: 1.5;
                  text-align: justify;
                }
      
                hr {
                  border: 0;
                  border-top: 1px solid #ccc;
                  margin: 10px 0;
                }
      
                .panel-body {
                  border: 1px solid #ddd;
                  padding: 15px;
                  background: #fff;
                }
      
                .shadow {
                  border: 1px solid #ccc;
                  border-radius: 5px;
                  padding: 10px;
                  margin-bottom: 10px;
                  background: #f9f9f9;
                }
      
                .job-data {
                  border-top: 1px solid #eee;
                  padding: 5px 0;
                }
      
                .row {
                  display: flex;
                  flex-wrap: wrap;
                  margin: 5px 0;
                }
      
                .col-lg-3 {
                  flex: 0 0 25%;
                  max-width: 25%;
                  padding: 5px;
                }
      
                .col-lg-12, .col-md-12 {
                  flex: 0 0 100%;
                  max-width: 100%;
                  padding: 5px;
                }
      
                .bank-name {
                  background: #eee;
                  font-weight: bold;
                  padding: 5px;
                  border-bottom: 1px solid #ccc;
                }
      
                .disclaimer {
                  font-size: 12px;
                  color: #444;
                  margin-top: 15px;
                }
      
                /* ✅ Center logo */
                .home-top-logo {
                  display: block;
                  margin: 0 auto 10px auto;
                  max-height: 80px;
                }

                
              </style>
            </head>
            <body>
              ${content.innerHTML}
            </body>
          </html>
        `);

        printWindow.document.close();

        printWindow.onload = function () {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        };
    };

    getInterviewDate = (ticket) => {
        if (ticket.virtual_interview === '1' && ticket.physical_interview === '1') {
            return `Virtual(${ticket.virtual_interview_date}) & Physical(${ticket.physical_interview_date})`
        }
        else if (ticket.virtual_interview === '1') {
            return `Virtual(${ticket.virtual_interview_date})`
        } else if (ticket.physical_interview === '1') {
            return `Physical(${ticket.physical_interview_date})`
        } else {
            return ''
        }
    }

    getVenue = (ticket) => {
        if (ticket.virtual_interview === '1' && ticket.physical_interview === '1') {
            return `Virtual(${ticket.virtual_venue}) & Physical(${ticket.physical_venue})`
        }
        else if (ticket.virtual_interview === '1') {
            return `Virtual(${ticket.virtual_venue})`
        } else if (ticket.physical_interview === '1') {
            return `Physical(${ticket.physical_venue})`
        } else {
            return ''
        }
    }

    componentDidMount() {
        document.title = this.props.t('hallTicket.sidebar', { param: 'react' })
        store.dispatch(getHallTicketData(this.props.routeParams.id));
    }

    render() {
        if (localStorage.getItem('Islogin') !== 'true') {
            this.props.router.push('/');
        }

        let ticketData = this.props.JobseekerReducer.hallTicketForPrint
        let userData = this.props.JobseekerReducer.Profile
        let showTicket = this.props.actionReducer.activeJobMela.showTicket
        showTicket = 1

        return (
            <section className="back-dashboard widget-sidebar-context mt-3" id="my-sidebar-context">
                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        <Sidebar route={this.props.route} />
                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">
                            <div className="clearfix"></div>
                            <div className="tab-content">
                                <div id="home" className=" tab-pane active">
                                    <section className="login-form mt-0">
                                        <div className="panel-heading">
                                            <h6 className="mb-0">{this.props.actionReducer.activeJobMela && this.props.actionReducer.activeJobMela.jobMela ? this.props.actionReducer.activeJobMela.jobMela : ''}</h6>

                                        </div>
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-sm-12 col-lg-12 bg-education  mx-auto   p-0">
                                                    <div className="panel-body" ref={this.printRef}>
                                                        <div className="d-flex align-items-center w-100 justify-content-center">
                                                            <img alt="logo" src="/images/logo-new2.png" className="img-fluid pb-2 home-top-logo" />
                                                        </div>

                                                        <h5 className="text-center text-uppercase mb-3 fontW700">{this.props.t('jobMela.pgrkam', { param: 'react' })}</h5>
                                                        <h6 className="text-center text-uppercase fontW600">Hall Ticket for {ticketData[0]?.job_mela_name}</h6>
                                                        <p style={{ fontSize: "1rem", textAlign: 'justify' }}>You have applied for the following Jobs on https://punjabrozgar.org.in/ in the {ticketData[0]?.job_mela_name}. You are required to show your Hall ticket at the Interview Venue .Your credentials will be shared with the Employer(s). You may contact the District Bureau of Employment and Enterprises (DBEE) in case some clarification is required regarding the interviews in the {this.props.actionReducer.activeJobMela && this.props.actionReducer.activeJobMela.jobMela ? this.props.actionReducer.activeJobMela.jobMela : ''}
                                                            .</p>

                                                        {showTicket ? <>
                                                            <hr className="m-0"></hr>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <h6 className="text-center p-2 mb-0 fontW600">CANDIDATE INFORMATION</h6>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6" style={{ width: "50%" }}>
                                                                    <h6 className="fontW600">Name: {userData.firstname ? userData.firstname + ' ' + userData.lastname : ''}</h6>
                                                                    <h6 className="fontW600">District: {userData.district}</h6>
                                                                    <h6 className="fontW600">Gender: {userData.gender_name}</h6>
                                                                </div>
                                                                <div className="col-md-6" style={{ width: "50%" }}>
                                                                    <h6 className="fontW600">Date of Birth: {userData.dob ? userData.dob : "Information not Provided"}</h6>
                                                                    <h6 className="fontW600">Mobile: {userData.mobile}</h6>
                                                                    <h6 className="fontW600">Qualification: {userData.edu}</h6>
                                                                </div>
                                                            </div>
                                                            <p></p>
                                                            <hr></hr>
                                                            {ticketData && ticketData.length ? <>

                                                                <h5 className="text-center p-2 mb-0 fontW700"> Details of vacancies applied for in {this.props.actionReducer.activeJobMela && this.props.actionReducer.activeJobMela.jobMela ? this.props.actionReducer.activeJobMela.jobMela : ticketData[0]?.job_mela_name}</h5>
                                                                <h6 className="text-center p-2 mb-0 fontW500">Total Jobs Applied: {ticketData.length}</h6></> : null}
                                                            <div>
                                                                {ticketData && ticketData.length ? ticketData.map((ticket, key) => {
                                                                    return (
                                                                        <div key={key} className="shadow mb-3">
                                                                            <div className="bank-name text-center">
                                                                                <h6 className="mb-0 p-1 fontW600"> Employer Name :  {ticket.org_name}</h6>
                                                                            </div>
                                                                            <div className="row m-0 employervanue">
                                                                                <div
                                                                                    className="col-md-12 col-lg-12  text-left job-data mt-1">
                                                                                    <div className="row m-0">
                                                                                        <div className="col-lg-3 mr-3 fontW600 font-weight-bold w-20">Job Role</div>
                                                                                        <div className="col-lg-3">{ticket.job_title}</div>

                                                                                        <div className="col-lg-3 font-weight-bold fontW600 w-13">Eligiblity</div>
                                                                                        <div className="col-lg-3">{ticket.eligiblity}</div>
                                                                                    </div>
                                                                                    <div className="row m-0">
                                                                                        <div className="col-lg-3 mr-3 fontW600 font-weight-bold w-20 ">District/Dbee</div>
                                                                                        <div className="col-lg-3 w-25">{ticket.district}</div>
                                                                                        <div className="col-lg-3 mr-3 fontW600 w-13 font-weight-bold">Place of Posting</div>
                                                                                        <div className="col-lg-3 w-20" >{ticket.posting}</div>
                                                                                    </div>
                                                                                    <div className="row m-0">
                                                                                        <div className="col-lg-3 mr-3 fontW600 font-weight-bold w-20">Salary</div>
                                                                                        <div className="col-lg-3 w-25">{ticket.salary}</div>
                                                                                        <div className="col-lg-3 mr-3 fontW600 font-weight-bold w-13">Interview Date</div>
                                                                                        <div className="col-lg-3 w-20">{this.getInterviewDate(ticket)}</div>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-12 col-lg-12  text-left job-data mt-1">
                                                                                    {ticket.contact ? <div className="row m-0">
                                                                                        <div className="col-lg-3 mr-3 fontW600 font-weight-bold w-20">Dbee Contact</div>
                                                                                        <div className="col-lg-3 mr-5">{ticket.contact}</div>
                                                                                    </div>
                                                                                        : null}
                                                                                    <div className="row m-0">
                                                                                        <div className="col-lg-3 mr-3 fontW600 font-weight-bold w-20">Interview Venue</div>
                                                                                        <div className="col-lg-3 mr-5">{this.getVenue(ticket)}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }) : null}
                                                            </div>
                                                        </> :
                                                            <h6>{this.props.t('hallTicket.inst1', { param: 'react' })} {this.props.actionReducer.activeJobMela.dateFrom} {this.props.t('hallTicket.to', { param: 'react' })} {this.props.actionReducer.activeJobMela.dateTo}</h6>}
                                                        {ticketData && ticketData.notFound ?
                                                            <div>
                                                                <hr />
                                                                <p>You have not applied for any job in {this.props.actionReducer.activeJobMela && this.props.actionReducer.activeJobMela.jobMela ? this.props.actionReducer.activeJobMela.jobMela : ''} through <a
                                                                aria-label="Punjab Rozgar"
                                                                 href="http://pgrkam.com">http://pgrkam.com</a></p>
                                                            </div> : null}
                                                        {showTicket ? <p className="mt-4">Disclaimer: Merely applying for the jobs through this portal does not entitle you to be selected for the job(s) that you have applied. This portal is for the facilitation of the Jobseekers and the Employers.</p> : null}
                                                    </div>
                                                    {showTicket && ticketData && ticketData.length ?
                                                        // <ReactToPrint
                                                        //     trigger={() => <button
                                                        //         className={"btn btn-primart btn-primary2 print-btn mx-auto d-block mb-2 mt-2"}>
                                                        //         Print Hall Ticket
                                                        //     </button>}
                                                        //     content={() => this.printContent.current}
                                                        //     copyStyles={true}
                                                        // /> 
                                                        <button
                                                            aria-label="Print to PDF"
                                                            type="button"   
                                                            onClick={this.handlePrint}
                                                            className={"btn btn-primart btn-primary2 print-btn mx-auto d-block mb-2 mt-2"}
                                                        >
                                                            Print to PDF!
                                                        </button>

                                                        : null}
                                                    <h6 className="text-center fontW600">For contact details of the DBEE, <Link to="/employment" className="fontW500">Click Here</Link></h6>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </section>
        )
    }
}


const mapStateToProps = store => {
    return store;
};

export default connect(mapStateToProps)(translate(HallTicket));
